<template>
  <div v-if="isShow && myOption.series">
    <table :style="{ width: tableWidth, fontSize: tableFontSize }" tableframe="void" rules=none cellspacing=0>
      <tr>
        <th class="table-col-1"></th>
        <th class="table-col-2"></th>
        <th class="table-col-3" :style="{ width: valueWidth }">min</th>
        <th class="table-col-4" :style="{ width: valueWidth }">max</th>
        <th class="table-col-5" :style="{ width: valueWidth }">avg</th>
      </tr>
      <tr v-for="(item, index) in myOption.series" :key="'option_index_' + index">
        <td>
          <div :style="{ backgroundColor: colors[index] }"></div>
        </td>
        <td>{{ item.name }}</td>
        <td>{{ getMin(item.data) }}</td>
        <td>{{ getMax(item.data) }}</td>
        <td>{{ getAvg(item.data) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object
    },
    tableWidth: {
      type: String,
      default: '100%'
    },
    tableFontSize: {
      type: String,
      default: '14px'
    },
    valueWidth: {
      type: String,
      default: '80px'
    },
    unit: {
      type: String,
      default: ''
    }
  },
  watch: {
    option () {
      this.init()
    }
  },
  data () {
    return {
      colorUseIndex: 0,
      isShow: false,
      myOption: {},
      colors: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      if (this.option) {
        this.getColor(this.option.series, this.option.color)
        this.myOption = this.option
        this.isShow = true
      }
    },
    getColor (series, colors) {
      for (let i in series) {
        if (series[i].itemStyle.color) {
          this.colors.push(series[i].itemStyle.color)
        } else {
          let color = colors[this.colorUseIndex]
          this.colorUseIndex = this.colorUseIndex + 1
          this.colors.push(color)
        }
      }
    },
    getMax (dataFrame) {
      let result = null
      let data = []
      for (let i in dataFrame) {
        if (dataFrame.length > 2) {
          if (dataFrame[i][1] !== null) {
            data.push(dataFrame[i][1])
          }
        }
      }
      if (data.length) {
        result = Math.max.apply(null, data)
      }
      result = this.formatData(result)
      return result
    },
    getMin (dataFrame) {
      let result = null
      let data = []
      for (let i in dataFrame) {
        if (dataFrame.length > 2) {
          if (dataFrame[i][1] !== null) {
            data.push(dataFrame[i][1])
          }
        }
      }
      if (data.length) {
        result = Math.min.apply(null, data)
      }
      result = this.formatData(result)
      return result
    },
    getAvg (dataFrame) {
      let result = null
      let dataLen = 0
      let sum = 0
      let isNull = true
      for (let i in dataFrame) {
        if (dataFrame.length > 2) {
          if (dataFrame[i][1] !== null) {
            isNull = false
            sum += dataFrame[i][1]
            dataLen += 1
          }
        }
      }
      if (isNull) {
        return 'null'
      } else if (dataLen > 0) {
        result = sum / dataLen
      } else {
        return 0
      }
      if (result.toString().split('.').length > 1) {
        if (result.toString().split('.')[1].length > 2) {
          result = result.toFixed(2)
        }
      }
      result = this.formatData(result)
      return result
    },
    formatData (value) {
      let unit = ''
      let isAbs = ''
      if (value < 0) {
        isAbs = '-'
        value = Math.abs(value)
      }
      if (value >= 1024 * 1024 * 1024) {
        value = (value / (1024 * 1024 * 1024)).toFixed(1)
        unit = ' GB'
      } else if (value >= 1024 * 1024) {
        value = (value / (1024 * 1024)).toFixed(1)
        unit = ' MB'
      } else if (value >= 1024) {
        value = (value / 1024).toFixed(1)
        unit = ' KB'
      }
      if (this.unit && value !== null && !unit) {
        value = value + this.unit
      }
      return isAbs + value + unit
    }
  }
}
</script>

<style scoped lang="less">
  table {
    text-align: center;
    tr {
      .table-col-1 {
        width: 30px;
      }
      th {
        color: #30A5D1
      }
      td {
        height: 25px;
        color: #fff
      }
      td:nth-child(1) {
        padding-left: 5px;
        div {
          width: 15px;
          height: 3px;
          display: block;
        }
      }
      td:nth-child(2) {
        text-align: left;
      }
    }
    tr:nth-child(1){
      background: #1E1C1D !important;
    }
    tr:nth-child(odd){
      background: #282828;
    }
  }
</style>
